import { useState, useEffect } from "react";
import useAuthStore from "../../../../store/authStore";
import { updateAdmin,insertAdmin} from "../../services/adminPanel_service";
import { toast } from "react-toastify";

const AdminUserModal = ({ 
    show,
  mode = "add",       // "add" | "edit"
  initialData = null, // row data from grid
  onClose,
  onSuccess
 }) => {
    const currentUserId = useAuthStore.getState().user;
  const [form, setForm] = useState({
    userName: "",
    password: "",
    confirmPassword: "",
    firstName: "",
    lastName: "",
    role: "",
    email: ""
  });

  const roles = [
    { roleId: 1, roleName: "Super Admin" },
    { roleId: 2, roleName: "Admin" },
    { roleId: 3, roleName: "User" }
  ];

  const PASSWORD_RULES = [
  { regex: /[A-Z]/,        message: "at least one uppercase letter" },
  { regex: /[a-z]/,        message: "at least one lowercase letter" },
  { regex: /[0-9]/,        message: "at least one numeric digit" },
  { regex: /[^A-Za-z0-9]/, message: "at least one special character" },
  { test: (v) => v.length >= 8, message: "minimum 8 characters" }
];

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const validateForm = (form, mode) => {
  const errors = [];

  // ── Username ──
  if (!form.userName.trim()) {
    errors.push("User Name is required.");
  }

  // ── Password (always required on add; optional on edit if left blank) ──
  const isPasswordProvided = form.password.trim().length > 0;

  if (mode === "add" && !isPasswordProvided) {
    errors.push("Password is required.");
  }

  if (isPasswordProvided) {
    const failedRules = PASSWORD_RULES.filter(rule =>
      rule.regex ? !rule.regex.test(form.password) : !rule.test(form.password)
    );
    if (failedRules.length > 0) {
      errors.push(`Password must contain ${failedRules.map(r => r.message).join(", ")}.`);
    }

    if (form.password !== form.confirmPassword) {
      errors.push("Password and Confirm Password do not match.");
    }
  }

  // ── Role ──
  if (!form.role) {
    errors.push("Please select a Role.");
  }

  // ── Email ──
  if (!form.email.trim()) {
    errors.push("Email is required.");
  } else if (!EMAIL_REGEX.test(form.email.trim())) {
    errors.push("Please enter a valid Email address.");
  }

  return errors;
};

  const buildAddDto = (form, currentUserId) => {
  return {
    UserId: 0,
    UserName: form.userName,
    Password: form.password,
    CreatedBy: currentUserId,
    CreatedDate: new Date(),
    LastLoginDate: null,
    LastLogin: null,
    IsActive: true,
    IsMFASetup: false,
    FirstName: form.firstName,
    LastName: form.lastName,
    Salutation: "",
    EmailAddress: form.email,
    RoleId: Number(form.role),
    RoleName: "",

    ModifiedBy: currentUserId,
    ModifiedDate: new Date(),

    ResetPassword: null,
    PasswordTemporary: false,
    LoginAttempts: 0,
    LastPasswordReset: new Date(),
    IsLocked: 0,
    LoginIp: null,
    LockReason: null,
    CategoryId: 0,
    ResetPasswordUniqueID: null,
    WebStatusId: 1,
    token: null,
    AuthKey: null
  };
};

const buildEditDto = (form, initialData, currentUserId) => {
  return {
    ...initialData,

    firstName: form.firstName,
    lastName: form.lastName,
    emailAddress: form.email,
    roleId: Number(form.role),

    password: form.password || initialData.Password,
    modifiedBy: currentUserId,
    modifiedDate: new Date()
  };
};

  useEffect(() => {
    if (mode === "edit" && initialData) {
      setForm({
        userName: initialData.userName || "",
        password: initialData.password,
        confirmPassword: "", // keep empty for security
        firstName: initialData.firstName || "",
        lastName: initialData.lastName || "",
        role: initialData.roleId || "", // must match roleId
        email: initialData.emailAddress || ""
      });
    }

    if (mode === "add") {
      setForm({
        userName: "",
        password: "",
        confirmPassword: "",
        firstName: "",
        lastName: "",
        role: "",
        email: ""
      });
    }
  }, [mode, initialData]);

  if (!show) return null;

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async () => {
    const errors = validateForm(form, mode);
    if (errors.length > 0) {
      // Fire one toast per error so each is individually visible
      errors.forEach(msg => toast.error(msg));
      return;
    }

  let payload;

  if (mode === "add") {
    try{
        payload = buildAddDto(form, currentUserId);
        await insertAdmin(payload)
        toast.success('User inserted successfully')
    }
    catch{
        toast.error('Unable to add user')
    }
  } else {
    try{
        payload = buildEditDto(form, initialData, currentUserId);
        await updateAdmin(payload)
        toast.success('User updated successfully')
    }
    catch{
        toast.error('Unable to update user')
    }
  }

  onSuccess && onSuccess();
  onClose();
};

  return (
    <>
      <div className="modal fade in" style={{ display: "block" }}>
        <div className="modal-dialog" style={{ width: "650px" }}>
          <div className="modal-content">

            {/* HEADER — FIXED SIZE */}
            <div
              className="modal-header"
              style={{ padding: "0px 0px" }}   // smaller header
            >
              <button
                type="button"
                className="close"
                onClick={onClose}
              >
                &times;
              </button>
              <h4
                className="modal-title"
                style={{ margin: 0 }}   // remove extra spacing
              >
                Insert / Update Admin User
              </h4>
            </div>

            {/* BODY */}
            <div className="modal-body">

              {/* IMPORTANT: form-horizontal */}
              <form className="form-horizontal">

                <div className="form-group">
                  <label className="col-sm-4 control-label" style={{textAlign:'left'}}>
                    User Name :
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="text"
                      className="form-control"
                      name="userName"
                      value={form.userName}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label className="col-sm-4 control-label" style={{textAlign:'left'}}>
                    Password :
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="password"
                      className="form-control"
                      name="password"
                      value={form.password}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label className="col-sm-4 control-label" style={{textAlign:'left'}}>
                    Confirm Password :
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="password"
                      className="form-control"
                      name="confirmPassword"
                      value={form.confirmPassword}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label className="col-sm-4 control-label" style={{textAlign:'left'}}>
                    First Name :
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="text"
                      className="form-control"
                      name="firstName"
                      value={form.firstName}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label className="col-sm-4 control-label" style={{textAlign:'left'}}>
                    Last Name :
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="text"
                      className="form-control"
                      name="lastName"
                      value={form.lastName}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label className="col-sm-4 control-label" style={{textAlign:'left'}}>
                    Role :
                  </label>
                  <div className="col-sm-8">
                    <select
                className="form-control"
                value={form.role || ""}
                onChange={handleChange}
                name="role"
              >
                <option value="" >Select</option>
                {roles.map(s => (
                  <option key={s.roleId} value={s.roleId}>
                    {s.roleName}
                  </option>
                ))}
              </select>
                  </div>
                </div>

                <div className="form-group">
                  <label className="col-sm-4 control-label" style={{textAlign:'left'}}>
                    Email :
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="text"
                      className="form-control"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                    />
                  </div>
                </div>

              </form>
            </div>

            {/* FOOTER */}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSubmit}
              >
                Save
              </button>

              <button
                type="button"
                className="btn btn-default"
                onClick={onClose}
              >
                Cancel
              </button>
            </div>

          </div>
        </div>
      </div>

      {/* Backdrop intentionally removed as requested */}
      {/*
      <div
        className="modal-backdrop fade in"
        onClick={onClose}
      />
      */}
    </>
  );
};

export default AdminUserModal;